import { z } from 'zod';
import { CoreNotifyCommunicationAttemptDirectionTypeSchema } from '../inputTypeSchemas/CoreNotifyCommunicationAttemptDirectionTypeSchema'
import { CoreNotifyCommunicationTypeSchema } from '../inputTypeSchemas/CoreNotifyCommunicationTypeSchema'
import { CoreNotifyCommunicationChannelTypeSchema } from '../inputTypeSchemas/CoreNotifyCommunicationChannelTypeSchema'
import { CoreNotifyCommunicationStatusTypeSchema } from '../inputTypeSchemas/CoreNotifyCommunicationStatusTypeSchema'
import { CoreNotifyCommunicationAttemptTwilioStatusTypeSchema } from '../inputTypeSchemas/CoreNotifyCommunicationAttemptTwilioStatusTypeSchema'

/////////////////////////////////////////
// CORE NOTIFY COMMUNICATION ATTEMPT SCHEMA
/////////////////////////////////////////

export const CoreNotifyCommunicationAttemptSchema = z.object({
  direction: CoreNotifyCommunicationAttemptDirectionTypeSchema,
  communicationType: CoreNotifyCommunicationTypeSchema,
  channelType: CoreNotifyCommunicationChannelTypeSchema,
  status: CoreNotifyCommunicationStatusTypeSchema,
  twilioStatus: CoreNotifyCommunicationAttemptTwilioStatusTypeSchema.nullable(),
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  reasonCode: z.string().nullable(),
  reasonText: z.string().nullable(),
  smsSegments: z.number().int().nullable(),
  voiceDurationInSeconds: z.number().int().nullable(),
  twilioSid: z.string().nullable(),
  massNotificationId: z.bigint().nullable(),
  anonymousContactId: z.number().int().nullable(),
  subscriberContactMethodId: z.number().int().nullable(),
  billingTransactionId: z.number().int().nullable(),
})

export type CoreNotifyCommunicationAttempt = z.infer<typeof CoreNotifyCommunicationAttemptSchema>

export default CoreNotifyCommunicationAttemptSchema;
